import { render, staticRenderFns } from "./attribute.vue?vue&type=template&id=50d2c6e1&scoped=true&"
import script from "./attribute.vue?vue&type=script&lang=js&"
export * from "./attribute.vue?vue&type=script&lang=js&"
import style0 from "./attribute.vue?vue&type=style&index=0&id=50d2c6e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d2c6e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50d2c6e1')) {
      api.createRecord('50d2c6e1', component.options)
    } else {
      api.reload('50d2c6e1', component.options)
    }
    module.hot.accept("./attribute.vue?vue&type=template&id=50d2c6e1&scoped=true&", function () {
      api.rerender('50d2c6e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/mine_nav/attribute.vue"
export default component.exports